import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { ChartPoint, ReferenceLine } from '../patient-chart.component';

@Component({
  selector: 'csi-patient-chart-tooltip',
  templateUrl: './patient-chart-tooltip.component.html',
  styleUrls: ['./patient-chart-tooltip.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientChartTooltipComponent implements OnInit, OnChanges, OnDestroy {
  @Input() point: ChartPoint;
  @Input() referenceLines: ReferenceLine[];

  public title: string;
  public score: number | string;
  public units: string;
  public severity: string;
  public date: Date;

  private translations: { [key: string]: string } = {};
  private translationSub: Subscription;

  constructor(private translocoService: TranslocoService) {}

  ngOnInit() {
    this.translationSub = this.translocoService
      .selectTranslateObject('PATIENT_CHART')
      .subscribe(map => {
        this.translations = map;
        this.recomputeAll();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['referenceLines'] && this.referenceLines) {
      this.referenceLines.sort((a, b) => b.value - a.value);
    }
    this.recomputeAll();
  }

  ngOnDestroy() {
    if (this.translationSub) {
      this.translationSub.unsubscribe();
    }
  }

  private recomputeAll() {
    if (!this.point || !this.translations) {
      return;
    }

    this.date = this.point.date;

    const rawScore = String(this.point.displayValue);
    if (this.translations[rawScore] != null) {
      this.score = this.translations[rawScore];
    } else {
      this.score = rawScore;
    }

    const rawUnits = this.point.units || '';
    if (this.translations[rawUnits] != null) {
      this.units = this.translations[rawUnits];
    } else {
      this.units = rawUnits;
    }

    const rawSeries = this.point.series;
    if (this.translations[rawSeries] != null) {
      this.title = this.translations[rawSeries];
    } else {
      this.title = rawSeries;
    }

    this.updateSeverity();
  }

  private updateSeverity() {
    if (!this.referenceLines) {
      this.severity = '';
      return;
    }
    const norm = this.point.normalizedValue;
    let rawKey = '';
    for (let i = 1; i < this.referenceLines.length; i++) {
      const rl = this.referenceLines[i];
      if (norm >= rl.value) {
        rawKey = rl.name;
        break;
      }
    }
    if (!rawKey) {
      this.severity = '';
    } else if (this.translations[rawKey] != null) {
      this.severity = this.translations[rawKey];
    } else {
      this.severity = rawKey;
    }
  }
}
